<template>
  <li
    class="message-list-item"
    :class="{ 'is-unread': !message.readStatus }"
    @click="debounceHandleMessageClick"
  >
    <div class="message-list-item__content">{{ message.content }}</div>
    <div class="message-ist-item__date">{{ message.createTime }}</div>
  </li>
</template>
<script>
import { mapActions } from 'vuex'
import { debounce } from '@/utils/performance.js'
import JSONbig from 'json-bigint'

export default {
  props: {
    message: {
      type: Object,
      default: () => {
        return {
          content: '',
          createTime: '',
          id: 0,
          readStatus: 1
        }
      }
    }
  },
  data() {
    return {
      debounceHandleMessageClick: debounce(this.handleMessageClick, 500)
    }
  },
  methods: {
    handleMessageClick() {
      if (this.message.readStatus === 0) {
        this.readMessage({ id: this.message.id }).then(() => {
          this.getHasUnReadMessage()
          this.judgeIsGoLoanDetail()
        })
      } else {
        this.judgeIsGoLoanDetail()
      }
    },
    judgeIsGoLoanDetail() {
      const extJson = JSONbig.parse(this.message.extJson)
      if (!extJson.applyId.toString()) return
      this.$router.push({
        path: `/my/loan-detail/${extJson.applyId.toString()}`
      })
    },
    ...mapActions('message', ['readMessage', 'getHasUnReadMessage'])
  }
}
</script>
<style lang="scss" scoped>
.message-list-item {
  margin-left: 25px;
  margin-bottom: 20px;
  display: flex;
  color: $second-text-color;
  position: relative;
  cursor: pointer;

  &.is-unread {
    color: $primary-text-color;
    &::before {
      content: '';
      display: block;
      margin-left: -20px;
      width: 7px;
      height: 7px;
      background: rgba(230, 0, 18, 1);
      border-radius: 50%;
      position: absolute;
      left: -2px;
      top: 7px;
    }
  }
  &__content {
    text-align: left;
    flex-grow: 1;
  }
  &__date {
    width: 180px;
    flex-grow: 0;
  }
}
</style>
